var _path, _circle, _circle2, _g, _path2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreFiltersEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 34C40 32.5 70 31 82 32C86 32.5 88.5 36 88.5 40C88.5 48 86 56 81 64C73 77 58 89.5 42.5 89.5C26 89.5 10 79 5.5 66C3 60 3 55 3 52C3 46 6 41 10 38.5C14 36 19 34.5 24 34Z",
    fill: "#FFF2A6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35,
    r: 32,
    stroke: "black",
    strokeWidth: 1.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 34.5,
    r: 21,
    stroke: "black",
    strokeWidth: 1.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: -4.45,
    width: 9.5,
    height: 8.3,
    fill: "#FFE339",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5 -8.15H113.65A7.85 7.85 0 0 1 113.65 7.55H91.5Z",
    fill: "#FFE339",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 30Q60 2 85 30Q60 57 35 30Z",
    fill: "#FFE339",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.75,
    cy: 29.9,
    r: 8.25,
    fill: "#FFF2A6",
    stroke: "black",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 30.2A3.5 3.5 0 0 1 59.75 26.4",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreFiltersEmpty);
export default __webpack_public_path__ + "static/media/more-filters-empty.a43418d3.svg";
export { ForwardRef as ReactComponent };